import { useEffect } from 'react'
import { fxSplash, fxSonarRing } from '../../assets/index.js'
import { useAnimation } from '../../hooks/useAnimation.js'
import { useAudio } from '../../hooks/useAudio.js'
import { CELL_SIZE } from '../Grid/Cell.js'

interface SplashFXProps {
  /** Pixel position of the target cell within the grid */
  x: number
  y: number
  onDone: () => void
}

/**
 * Strike Miss animation: splash (400ms) + cosmetic ripple (800ms).
 * ART_GUIDE_v2 §2.1
 */
export function SplashFX({ x, y, onDone }: SplashFXProps) {
  const { phaseTimer, reduceMotion } = useAnimation()
  const { play } = useAudio()

  useEffect(() => {
    play('strike-miss', 'combat')
    // Total: 400ms splash + transition to done
    const cleanup = phaseTimer(400, onDone)
    return cleanup
  }, [phaseTimer, onDone, play])

  const base: React.CSSProperties = {
    position: 'absolute',
    left: x,
    top: y,
    width: CELL_SIZE,
    height: CELL_SIZE,
    pointerEvents: 'none',
    zIndex: 10,
  }

  return (
    <>
      {/* Main splash */}
      <img
        src={fxSplash}
        alt=""
        draggable={false}
        style={{
          ...base,
          animation: reduceMotion
            ? 'splash-out 150ms ease-out forwards'
            : 'splash-in 100ms cubic-bezier(0.22,1,0.36,1) forwards, splash-out 300ms ease-in 100ms forwards',
        }}
      />
      {/* Cosmetic ripple — extends beyond cell, below markers */}
      {!reduceMotion && (
        <img
          src={fxSonarRing}
          alt=""
          draggable={false}
          style={{
            ...base,
            filter: 'hue-rotate(180deg)',
            opacity: 0.4,
            animation: 'ripple 800ms cubic-bezier(0.22,1,0.36,1) 250ms forwards',
            zIndex: 5,
          }}
        />
      )}
    </>
  )
}
